"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStorageForRedux = exports.setStorageForRedux = exports.getStorage = exports.setStorage = void 0;
// 本地存储相关
var __1 = require("../");
var REDUXPRE = 'Redux';
/**
 * @description 用法同localStorage.setItem 如果需要存入对象 请自行stringify
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {string} key 存入storage的key
 * @param {string} value 存入storage的value
 * @returns {void}
 * @example
 * setStorage('a', 1);
 * setStorage('b', JSON.stringify([1,2,3]))
 */
var setStorage = function (key, value) {
    localStorage.setItem(key, value);
};
exports.setStorage = setStorage;
/**
 * @description 用法同localStorage.getItem
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {string} key 存入storage的key
 * @param {T} defaultValue 可选参数 如果根据key取到的值为```undefined```或```null``` 则返回该默认值
 * @returns {T | string | undefined}
 * @example
 * setStorage('a');
 * setStorage('b', [1,2,3]
 */
var getStorage = function (key, defaultValue) {
    var value = localStorage.getItem(key);
    return value !== null && value !== void 0 ? value : defaultValue;
};
exports.getStorage = getStorage;
/**
 * @description setStorage的升级版本 会自动对value进行stringify并以加密形式存入
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {string} key 存入storage的key
 * @param {string} model 存入storage的模块名
 * @param {T} value 存入storage的value 自动对value进行stringify并以加密形式存入
 * @returns {void}
 * @example
 * setStorageForRedux('a', 'user', 10086);
 * setStorageForRedux('b', 'card', [1,2,3]);
 */
var setStorageForRedux = function (key, model, value) {
    var stringifyValue = JSON.stringify(value);
    var encryptionValue = __1.encryption('AES', stringifyValue);
    localStorage.setItem(REDUXPRE + "_" + model + "_" + key, encryptionValue);
};
exports.setStorageForRedux = setStorageForRedux;
/**
 * @description getStorage的升级版本 会自动对获取到的内容进行parse并解密
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {string} key 存入storage的key
 * @param {string} model 存入storage的模块名
 * @param {T} defaultValue 可选参数 如果根据key取到的值为```undefined```或```null``` 则返回该默认值
 * @returns {T | V | undefined}
 * @example
 * getStorageForRedux('a', 'user');
 * getStorageForRedux('b', 'card', '返回的默认值');
 */
var getStorageForRedux = function (key, model, defaultValue) {
    var value = localStorage.getItem(REDUXPRE + "_" + model + "_" + key);
    if (!__1.isString(value)) {
        return defaultValue;
    }
    var decryptionValue = __1.decryption('AES', value);
    var parseValue = JSON.parse(decryptionValue);
    return parseValue;
};
exports.getStorageForRedux = getStorageForRedux;
